// production URLs
export const BACKEND_HTTP_BASE_URL = "https://chatbot.homefirstindia.com:8443/homefirstchatbot/v1";
export const CHAT_API_URL = `${BACKEND_HTTP_BASE_URL}/chat`;
export const BRANCH_SEARCH_BASE_URL = "https://chatbot.homefirstindia.com:8443/homefirstchatbot/v1";
export const LEAD_CREATE_URL = `${BACKEND_HTTP_BASE_URL}/Lead.create`;
export const SERVICE_REQUEST_URL = `${BACKEND_HTTP_BASE_URL}/addServiceRequest`;


// local urls
// export const BACKEND_HTTP_BASE_URL = "http://127.0.0.1:8000/homefirstchatbot/v1";
// export const CHAT_API_URL = `${BACKEND_HTTP_BASE_URL}/chat`;
// export const BRANCH_SEARCH_BASE_URL = BACKEND_HTTP_BASE_URL;
// export const LEAD_CREATE_URL = `${BACKEND_HTTP_BASE_URL}/Lead.create`;
// export const SERVICE_REQUEST_URL = `${BACKEND_HTTP_BASE_URL}/addServiceRequest`;

// Common messages
export const DUPLICATE_LEAD_MESSAGE =
  "Good news! We’ve found your existing loan inquiry.\n\nTrack your loan status here: https://customers.homefirstindia.com/selfOnBoarding/loanTracking";

// Loan Type Options
export const loanTypeOptions = [
  "Home Loan",
  "Home Loan Balance Transfer",
  "Loan Against Property",
  "Home Construction Loan",
  "Commercial Property Loan"
];

// Initial Homepage Options
export const initialOptions = [
  "New Loan Inquiry",
  "Existing Customer",
  "Calculators",
  // "FAQ  jbcs",
  "Contact Us"
];

// Service Request Types and Subtypes
export const serviceRequestTypes = {
  "Auto Prepay": ["Activate Auto Prepay"],
  "Customer Queries": ["Address Change", "Contact Number Change"],
  "Documents Request": [
    "Account Statement",
    "Interest Certificate",
    "Provisional Certificate",
    "Receipt"
  ],
  "Auto Debit - NACH Mandate": [
    "Stop Auto Debit - Next Pre-EMI/EMI",
    "Cancel Auto Debit NACH facility"
  ],
  "Top Up Loan": [
    "Home Improvement / Furnishing",
    "Buy Out of Existing Debts",
    "Investment in Business",
    "Family Function",
    "Medical Purpose",
    "Land / Property Purchase",
    "Car Purchase",
    "Two Wheeler Purchase",
    "Education Purpose",
    "Others"
  ]
};

// Indian States and Union Territories
export const indianStatesAndUT = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry"
];


